import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconEye24 = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	fill: "none",
	viewBox: "0 0 24 24",
	ref,
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "currentColor",
		children: [/* @__PURE__ */ _jsx("path", { d: "M12 14.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5" }), /* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			d: "M6.257 6.81 2.739 10.65a2 2 0 0 0 0 2.702l3.518 3.838A2.5 2.5 0 0 0 8.1 18h7.8a2.5 2.5 0 0 0 1.843-.81l3.518-3.839a2 2 0 0 0 0-2.702L17.743 6.81A2.5 2.5 0 0 0 15.9 6H8.1a2.5 2.5 0 0 0-1.843.81M4.213 12l3.518-3.838A.5.5 0 0 1 8.1 8h7.8a.5.5 0 0 1 .369.162L19.787 12l-3.518 3.838A.5.5 0 0 1 15.9 16H8.1a.5.5 0 0 1-.369-.162z",
			clipRule: "evenodd"
		})]
	})
});
const ForwardRef = forwardRef(SvgIconEye24);
export default ForwardRef;
